import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    body: 'We will now ask you to:\n\n- Provide the supporting documents needed to open your SASU and your Shine pro account\n\n- Proceed to identity verification and payment for the creation of your SASU',
    cta: 'Continuer',
    title: 'Tell us more about your company creation project',
  },

  fr: {
    body: 'Nous allons vous demander de\u00A0:\n\n- Fournir les pièces justificatives nécessaires pour l’ouverture de votre SASU et de votre compte pro Shine\n\n- Procéder à la vérification d’identité et le paiement pour la création de votre SASU',
    cta: 'Continuer',
    title: 'Merci pour toutes ces informations\u00A0!',
  },
});

export default locales;
